import React from "react";

// Chakra imports
import {
  Box,
  SimpleGrid,
  Card
} from "@chakra-ui/react";

// Custom components
import Stocks from "../stocks/components/Stocks";

export default function Overview() {

  return (
    <Box pt={{ base: "180px", md: "80px", xl: "80px" }}>
      <SimpleGrid 
        mb='20px' 
        columns={{ base: 1, md: 1, xl: 1 }} 
        spacing={{ base: "20px", xl: "20px" }}>
        <Card px='0px'>
          <Stocks
          />
        </Card>
      </SimpleGrid>
    </Box>
  );
}
